import { Tooltip } from 'antd';
import classNames from 'classnames';

import { TOOLTIP_PLACEMENT, UNIT_MEASURE } from '@common/constants';
import cssColors from '@common/css/cssColors.module.scss';
import formatUOM from '@common/helpers/formatUOM';
import { getOnTrendLabelFromProduct } from '@common/helpers/onTrendLabel';
import { ApplianceModel, ApplianceType } from '@common/models';
import { getProductDescription } from '@common/utils';
import { formatPriceUnitOrFree } from '@common/utils/formatPriceUnitOrFree';
import ApplianceDragableImage from '@core/components/ApplianceDragableImage/ApplianceDragableImage';
import InstructionsBanner from '@core/components/instructions-banner/InstructionsBanner';
import ImageUtils from '@core/utils/ImageUtils';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { selectSelectedDishwasherId, updateSelectedDishwasherId } from '@redux/slices/dishwasherSlice';

const DishwasherItem = ({ dishwasher }: { dishwasher: ApplianceModel }): JSX.Element => {
    const dispatch = useAppDispatch();
    const selectedDishwasherId = useAppSelector(selectSelectedDishwasherId);

    const description = getProductDescription(dishwasher);

    const onTrendLabel = getOnTrendLabelFromProduct(dishwasher);

    const isSelected = dishwasher.productId === selectedDishwasherId;
    const unitOfMeasure = formatUOM(dishwasher.unitOfMeasure || UNIT_MEASURE.DISHWASHER);
    const clonedDishwasher = {
        ...dishwasher,
        applianceType: ApplianceType.DISHWASHER,
    };
    return (
        <div
            className={classNames('card-option', { selected: isSelected })}
            onMouseUp={() => {
                dispatch(updateSelectedDishwasherId(dishwasher.productId));
            }}
        >
            {onTrendLabel && <div className="on-trend">{onTrendLabel}</div>}
            <ApplianceDragableImage
                alt="dishwasher"
                className="card-option__image"
                src={ImageUtils.imgUrl(dishwasher.beautyShotImageUrl ?? dishwasher.imageUrl, 300)}
                applianceModel={clonedDishwasher}
            />
            <InstructionsBanner className="card-option__banner" hidden={!isSelected} />
            <Tooltip title={description} color={cssColors.toolTipColor} placement={TOOLTIP_PLACEMENT}>
                <div className="name">{description}</div>
            </Tooltip>
            <div className="price">{formatPriceUnitOrFree(dishwasher.price, unitOfMeasure)}</div>
        </div>
    );
};

export default DishwasherItem;
